var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartSolid = function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.95.375A6.032 6.032 0 0 0 11 2.951 6.05 6.05 0 0 0 0 6.42c0 2.864 1.526 5.742 4.537 8.552a42.167 42.167 0 0 0 6.23 4.583l.233.069.238-.069a48.208 48.208 0 0 0 6.22-4.583C20.556 12.168 22 9.45 22 6.42A6.055 6.055 0 0 0 15.95.375Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgHeartSolid;